import {
  Breadcrumb,
  Checkbox,
  Col,
  Input,
  message,
  Radio,
  Row,
  Select,
  Tabs,
} from "antd";
import _, { findIndex } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BackIcon, ChevronDown, ChevronUp, RoleStep } from "../../../asset";
import Accordion from "../../../component/accordion/Accordion";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import { ROUTES } from "../../../constant/routeConstant";
import style from "./RoleAdd.module.css";
import { doPost } from "./RoleService";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import { validRole } from "./validation";
import ModalConfirmLeave from "../../../component/modal/ModalConfirmLeave";
import { data } from "autoprefixer";
import { useDispatch, useSelector } from "react-redux";
import { onChanged } from "../../../util/Util";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";

const RoleAdd = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [index, setIndex] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [dataSent, setDataSent] = useState([]);
  const [parentMenu, setParentMenu] = useState([]);
  const [serviceMenu, setServiceMenu] = useState([]);
  const [itemMenu, setItemMenu] = useState([]);
  const [indexService, setIndexService] = useState();
  const [isOpenService, setIsOpenService] = useState();
  const [page, setPage] = useState(1);
  const [form, setForm] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [change, setChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [checkLv3, setCheckLv3] = useState([]);
  const [uncheckLv3, setUncheckLv3] = useState([]);
  const [load, setLoad] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFail, setMessageFail] = useState("");
  const navigate = useNavigate();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const handleChange = (value, name) => {
    setChange(true);
    onChanged(dispatch, true);
    if (name === "to_menu") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else {
      let eror = validRole(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    }
  };
  useEffect(() => {
    getParent();
  }, [dataSent]);

  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    let errors = {};
    let sub = {
      role_id: form.role_id,
      description: form.description,
    };
    for (const key in sub) {
      const option = validRole(key, sub[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      setPage(2);
    }
  };
  console.log("dataSent", dataSent);
  const onSubmit = async () => {
    const uniqueArray = dataSent.filter((arr, index) => {
      return dataSent.indexOf(arr) === index;
    });
    
    let errors = {};
    let sub = {
      ...form,
      permission: uniqueArray,
      level: 1,
    };
    for (const key in sub) {
      const option = validRole(key, sub[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      try {
        let tkn = `Grolog2023`;

        let param =
          "CLIENT_ID=3e3cb40e14d645eb8783f53a30c822d4&RESOURCE_USER_ID=1&GROLOG_ACCOUNT_ID=1";
        let res = await doPost(`/role?${param}`, token, sub);
        setSuccessModalOpen(true);
      } catch (err) {
        console.log("err", err?.response?.data?.payload);
        setMessageFail(err?.response?.data?.payload?.message);
        setFailedModalOpen(true);
      }
    }
  };

  const getParent = async () => {
    let sub = {
      permission_condition: "insert",
    };
    let res = await doPost(`/role/parentmenu?${param}`, token, sub);
    setParentMenu(res.data.payload.data);
  };

  const clickCard = async (i, id) => {
    if (isOpenService) {
      setServiceMenu("");
      setItemMenu("");
      setIndex("");
      setIsOpen(false);
      setIndexService("");
      setIsOpenService(false);
    } else {
      let sub = {
        permission_condition: "insert",
        menu_parent_id: id,
      };
      let res = await doPost(`/role/servicemenu?${param}`, token, sub);
      setServiceMenu(res.data.payload.data);
      setIndex(i);
      setIsOpen(isOpen ? false : true);
    }
  };
  const clickCardService = async (i, idParent, idService) => {
    let sub = {
      permission_condition: "insert",
      menu_parent_id: idParent,
      service_menu_id: idService,
    };
    let res = await doPost(`/role/itemmenu?${param}`, token, sub);
    setItemMenu(res.data.payload.data);
    setIndexService(i);
    setIsOpenService(isOpenService ? false : true);
  };

  const getItemService = async (idParent, idService, set, code, check) => {
    // setLoad(true)
    let check3 = [];
    let sub = {
      permission_condition: "insert",
      menu_parent_id: idParent,
      service_menu_id: idService,
    };
    let sub2 = {
      permission_condition: "insert",
      menu_parent_id: idParent,
      service_menu_id: serviceMenu[0].id,
    };
    let res = await doPost(`/role/itemmenu?${param}`, token, sub);

    let res2 = await doPost(`/role/itemmenu?${param}`, token, sub2);
    setCheckLv3([...checkLv3, res.data.payload.data]);
    // setUncheckLv3(res.data.payload.data);
    let dataMap = [...checkLv3, ...res.data.payload.data];
    let dataMap2 = [...res2.data.payload.data];
    dataMap2.map((el) => {
      if (
        dataSent[
          dataSent?.findIndex((permission) =>
            checkpermission(permission, el.code + ":" + set + "-own")
          )
        ] ===
        el.code + ":" + set + "-own"
      ) {
      } else {
        check3.push(el.code + ":" + set);
      }
    });
    dataMap.map((el) => {
      if (
        dataSent[
          dataSent?.findIndex((permission) =>
            checkpermission(permission, el.code + ":" + set + "-own")
          )
        ] ===
        el.code + ":" + set + "-own"
      ) {
      } else {
        check3.push(el.code + ":" + set);
      }
    });
    console.log("check yg ini", [
      ...dataSent,
      ...check,
      ...check3,
      code + ":" + set,
    ]);
    // setDataSent([...dataSent, ...check3]);
    let substringToRemove = "undefined";
    let array = [...dataSent, ...check, ...check3, code + ":" + set];
    array = array.filter((item) => !item.includes(substringToRemove));
    console.log("arr after remove", array);
    setDataSent(array);
    // setLoad(false)
  };

  const uncheckItemService = async (idParent, idService, set, code, check) => {
    // setLoad(true)
    let check3 = [];
    let sub = {
      permission_condition: "insert",
      menu_parent_id: idParent,
      service_menu_id: idService,
    };
    let res = await doPost(`/role/itemmenu?${param}`, token, sub);
    let dataMap = [...res.data.payload.data];
    _.forEach(dataMap, (el) => {
      if (
        dataSent[
          dataSent?.findIndex((permission) =>
            checkpermission(permission, el.code + ":" + set + "-own")
          )
        ] ===
        el.code + ":" + set + "-own"
      ) {
      } else {
        _.pull(check, `${el.code}:${set}`);
      }
    });
    // dataMap.map((el) => {
    //   check.splice(
    //     dataSent?.find((permission) => permission === el.code + ":" + set),
    //     1
    //   );
    // //   if(dataSent[dataSent?.findIndex((permission) =>
    // //     checkpermission(permission, el.code + ":" + set+"-own")
    // //   )] === el.code + ":" + set+"-own"){

    // // setDataSent(check);
    // //   }else{
    // //     check.splice(
    // //       dataSent?.findIndex((permission) =>
    // //         checkpermission(permission, el.code + ":" + set)
    // //       ),
    // //       1
    // //     );

    // // setDataSent(check);
    // //   }
    // });

    setDataSent(check);
    // setLoad(false)
  };

  function checkpermission(permission, code) {
    return permission === code;
  }

  const onChecked = (event, code, set, idParent) => {
    if (event.target.checked) {
      //set level 2 default
      let newDetail = [...dataSent];
      // setDataSent([...dataSent, code + ":" + set]);
      let check = [];

      serviceMenu.map((el) => {
        if (
          dataSent[
            dataSent?.findIndex((permission) =>
              checkpermission(permission, el.code + ":" + set + "-own")
            )
          ] ===
          el.code + ":" + set + "-own"
        ) {
          getItemService(idParent, el.id, set, code, check);
        } else {
          check.push(el.code + ":" + set);
          getItemService(idParent, el.id, set, code, check);
        }
      });
    } else {
      let newDetail = [...dataSent];
      let newDet = [...checkLv3];
      newDetail.splice(
        dataSent?.findIndex((permission) =>
          checkpermission(permission, code + ":" + set)
        ),
        1
      );

      //splice lv 2
      serviceMenu.map((el) => {
        if (
          dataSent[
            dataSent?.findIndex((permission) =>
              checkpermission(permission, el.code + ":" + set + "-own")
            )
          ] ===
          el.code + ":" + set + "-own"
        ) {
          uncheckItemService(idParent, el.id, set, code, newDetail);
        } else {
          _.pull(newDetail, `${el.code}:${set}`);
          // newDetail.splice(
          //   dataSent?.findIndex((permission) =>
          //     checkpermission(permission, el.code + ":" + set)
          //   ),
          //   1
          // );
          uncheckItemService(idParent, el.id, set, code, newDetail);
        }
      });

      // setDataSent(newDetail);
    }
  };

  const setRadio = (e, code) => {
    let newDetail = [...dataSent];
    if (
      dataSent[
        dataSent?.findIndex((i) => i === code + ":" + e.target.value)
      ] ===
      code + ":" + e.target.value
    ) {
      newDetail.splice(
        dataSent?.findIndex((i) => i === code + ":" + e.target.value),
        1
      );
      setDataSent([...newDetail]);
    } else {
      setDataSent([...newDetail, code + ":" + e.target.value]);
    }
  };

  const onRadio = (e, code, set) => {
    let newDetail = [...dataSent];
    if (e.target.value.split("-")?.length === 2) {
      if (
        dataSent[
          dataSent?.findIndex((i) => i === code + ":" + e.target.value)
        ] ===
        code + ":" + e.target.value
      ) {
        newDetail.splice(
          dataSent?.findIndex((permission) =>
            checkpermission(permission, code + ":" + e.target.value)
          ),
          1
        );
        setDataSent([...newDetail]);
      } else {
        if (
          dataSent?.findIndex((permission) =>
            checkpermission(permission, code + ":" + set)
          ) >= 0
        ) {
          newDetail.splice(
            dataSent?.findIndex((permission) =>
              checkpermission(permission, code + ":" + set)
            ),
            1
          );

          setDataSent([...newDetail, code + ":" + e.target.value]);
        } else {
          setDataSent([...newDetail, code + ":" + e.target.value]);
        }
      }
    } else {
      if (
        dataSent[
          dataSent?.findIndex((i) => i === code + ":" + e.target.value)
        ] ===
        code + ":" + e.target.value
      ) {
        newDetail.splice(
          dataSent?.findIndex((permission) =>
            checkpermission(permission, code + ":" + e.target.value)
          ),
          1
        );
        setDataSent([...newDetail]);
      } else {
        if (
          dataSent?.findIndex((permission) =>
            checkpermission(permission, code + ":" + set + "-own")
          ) >= 0
        ) {
          newDetail.splice(
            dataSent?.findIndex((permission) =>
              checkpermission(permission, code + ":" + set + "-own")
            ),
            1
          );

          setDataSent([...newDetail, code + ":" + e.target.value]);
        } else {
          setDataSent([...newDetail, code + ":" + e.target.value]);
        }
      }
    }
  };

  // const onRadio = (e, code, set+"-own") => {
  //   if (e.target.value.split("-")?.length === 2) {
  //     let newDetail = [...dataSent];
  //     let newCheck = [...checkLv3];
  //     let newUncheck = [...uncheckLv3];
  //     newDetail.splice(
  //       dataSent?.findIndex((permission) =>
  //         checkpermission(permission, code + ":" + set)
  //       ),
  //       1
  //     );
  //     newCheck.splice(
  //       checkLv3?.findIndex((permission) =>
  //         checkpermission(permission, code + ":" + set)
  //       ),
  //       1
  //     );
  //     newUncheck.splice(
  //       uncheckLv3?.findIndex((permission) =>
  //         checkpermission(permission, code + ":" + set)
  //       ),
  //       1
  //     );
  //     setCheckLv3([...newCheck, code + ":" + e.target.value]);
  //     setUncheckLv3([...newUncheck, code + ":" + e.target.value]);
  //     setDataSent([...newDetail, code + ":" + e.target.value]);
  //   } else {
  //     let newDetail = [...dataSent];
  //     let newCheck = [...checkLv3];
  //     let newUncheck = [...uncheckLv3];
  //     newDetail.splice(
  //       dataSent?.findIndex((permission) =>
  //         checkpermission(permission, code + ":" + set + "-own")
  //       ),
  //       1
  //     );
  //     newCheck.splice(
  //       checkLv3?.findIndex((permission) =>
  //         checkpermission(permission, code + ":" + set +"-own")
  //       ),
  //       1
  //     );
  //     newUncheck.splice(
  //       uncheckLv3?.findIndex((permission) =>
  //         checkpermission(permission, code + ":" + set +"-own")
  //       ),
  //       1
  //     );
  //     setCheckLv3([...newCheck, code + ":" + e.target.value]);
  //     setUncheckLv3([...newUncheck, code + ":" + e.target.value]);
  //     setDataSent([...newDetail, code + ":" + e.target.value]);
  //   }
  //   // }
  // };

  const Detail = () => {
    return (
      <>
        <div className="flex mt-8">
          <div>
            <div className="gap-[40px] mb-[24px]">
              {/* //one */}
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Role ID")}
                </label>
                <div className="flex w-[500px]">
                  <Input
                    status={error?.role_id ? "error" : ""}
                    className="mt-[8px] h-[47px] w-[500px]"
                    value={form?.role_id}
                    onChange={(value) => handleChange(value, "role_id")}
                  />
                </div>
                <div className="text-red-100">{error?.role_id}</div>

                <div className="w-[500px] mb-[24px] mt-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Description")}
                  </label>
                  <div className="flex w-[500px]">
                    <Input
                      status={error?.description ? "error" : ""}
                      className="mt-[8px] h-[47px] w-[500px]"
                      value={form?.description}
                      onChange={(value) => handleChange(value, "description")}
                    />
                  </div>
                  <div className="text-red-100">{error?.description}</div>
                </div>

                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[16px] font-medium">
                    {t("Level")}
                  </label>
                  <div className="flex w-[500px]">
                    <Select
                      defaultValue="1"
                      style={{ width: 500 }}
                      options={[{ value: "1", label: "1" }]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const Permission = () => {
    return (
      <>
        {parentMenu.map((el, i) => {
          return (
            <>
              {el.code !== "" &&
              el.code !== "monitoring" && el.code !== "" ? (
                <div>
                  <Accordion
                    address={"Level 1 - " + el.name}
                    onClick={() => clickCard(i, el.id)}
                    index={i}
                    i={index}
                    isOpen={isOpen}
                    // address={el.address}
                    body={
                      <>
                        {isOpen === true && i === index ? (
                          <>
                            <div className="flex ml-9 font-medium">
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  className="mr-2"
                                  checked={dataSent?.find(
                                    (permission) =>
                                      permission === el.code + ":view"
                                  )}
                                  disabled={el?.action?.find(
                                    (permission) => permission === "view"
                                  )}
                                  onChange={(event) =>
                                    onChecked(event, el.code, "view", el.id)
                                  }
                                />
                                View
                              </div>
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  className="mr-2"
                                  checked={dataSent?.find(
                                    (permission) =>
                                      permission === el.code + ":insert"
                                  )}
                                  disabled={el?.action?.find(
                                    (permission) => permission === "insert"
                                  )}
                                  onChange={(event) =>
                                    onChecked(event, el.code, "insert", el.id)
                                  }
                                />
                                Insert
                              </div>
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  className="mr-2"
                                  checked={dataSent?.find(
                                    (permission) =>
                                      permission === el.code + ":update"
                                  )}
                                  disabled={el?.action?.find(
                                    (permission) => permission === "update"
                                  )}
                                  onChange={(event) =>
                                    onChecked(event, el.code, "update", el.id)
                                  }
                                />
                                Update
                              </div>
                              <div
                                className={
                                  style.selectOptionContainer + " flex m-2"
                                }
                              >
                                <Checkbox
                                  className="mr-2"
                                  checked={dataSent?.find(
                                    (permission) =>
                                      permission === el.code + ":delete"
                                  )}
                                  disabled={el?.action?.find(
                                    (permission) => permission === "delete"
                                  )}
                                  onChange={(event) =>
                                    onChecked(event, el.code, "delete", el.id)
                                  }
                                />
                                Delete
                              </div>
                            </div>
                            <div>
                              {serviceMenu?.map((menu, i) => {
                                
                                return (
                                  <>
                                  
              {menu.code ?
              <>
                                    <div className="ml-10 pb-10">
                                      <div className="flex justify-between pt-[10px] pr-10 pb[10px] w-full">
                                        <div className="color-black font-medium mt-[10px] text-left text-2xl">
                                          Level 2 - {menu.name}
                                        </div>
                                        {
                                          menu.code === "order.shippingcostpayment" || menu.code === "order.invoice"|| menu.code === "report.logreport"
                                          ? <></>
                                          :
                                          <>
                                          <div
                                          // onClick={props.child}
                                          className="cursor-pointer ml-[40px] mt-[25px]"
                                          onClick={() =>
                                            clickCardService(i, el.id, menu.id)
                                          }
                                        >
                                          {isOpenService &&
                                          i === indexService ? (
                                            <img
                                              src={ChevronDown}
                                              alt="arrowUp"
                                            />
                                          ) : (
                                            <img
                                              src={ChevronUp}
                                              alt="arrowDown"
                                            />
                                          )}
                                        </div>
                                          </>
                                        }
                                        
                                      </div>
                                      {/* permission service */}
                                      <div className="flex font-medium">
                                        <div className={"m-2"}>
                                          <div className="mt-4">View</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              onChange={(e) =>
                                                onRadio(e, menu.code, "view")
                                              }
                                              className="flex"
                                              value={
                                                dataSent?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":view"
                                                ) >= 0
                                                  ? "view"
                                                  : dataSent?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code + ":view-own"
                                                    ) >= 0
                                                  ? "view-own"
                                                  : ""
                                              }
                                            >
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":view"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action === "view"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                                value="view"
                                              >
                                                All
                                              </Radio>
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":view"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                value="view-own"
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action === "view-own"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                              >
                                                Own
                                              </Radio>
                                            </Radio.Group>
                                          </div>
                                        </div>
                                        {menu.code ===
                                                    "order.shippingcostpayment" ? (
                                                    <>
                                                    <div className={"m-2"}>
                                          <div className="mt-4">Paid</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              onChange={(e) =>
                                                onRadio(e, menu.code, "paid")
                                              }
                                              className="flex"
                                              value={
                                                dataSent?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":paid"
                                                ) >= 0
                                                  ? "paid"
                                                  : dataSent?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code +
                                                          ":paid-own"
                                                    ) >= 0
                                                  ? "paid-own"
                                                  : ""
                                              }
                                            >
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":paid"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action === "paid"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                                value="paid"
                                              >
                                                All
                                              </Radio>
                                              </Radio.Group>
                                              </div>
                                              </div>
                                                    </>
                                                  ) : menu.code ===
                                                  "report.invoice" || menu.code ===
                                                  "order.invoice" ?(
                                                    <>
                                                    <div className={"m-2"}>
                                          <div className="mt-4">Export</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              onChange={(e) =>
                                                onRadio(e, menu.code, "export")
                                              }
                                              className="flex"
                                              value={
                                                dataSent?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":export"
                                                ) >= 0
                                                  ? "export"
                                                  : dataSent?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code +
                                                          ":export-own"
                                                    ) >= 0
                                                  ? "export-own"
                                                  : ""
                                              }
                                            >
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":export"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action === "export"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                                value="export"
                                              >
                                                All
                                              </Radio>
                                              </Radio.Group>
                                              </div>
                                              </div>
                                                    </>
                                                  ) : (
                                                    <>
                                        <div className={"m-2"}>
                                          <div className="mt-4">Insert</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              onChange={(e) =>
                                                onRadio(e, menu.code, "insert")
                                              }
                                              className="flex"
                                              value={
                                                dataSent?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":insert"
                                                ) >= 0
                                                  ? "insert"
                                                  : dataSent?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code +
                                                          ":insert-own"
                                                    ) >= 0
                                                  ? "insert-own"
                                                  : ""
                                              }
                                            >
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":insert"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action === "insert"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                                value="insert"
                                              >
                                                All
                                              </Radio>
                                              {/* <Radio
                                            onClick={dataSent?.findIndex((i)=>i === el.code+":insert")>=0?"":(e) =>
                                              setRadio(e, menu.code)
                                            }
                                            value="insert-own"
                                            disabled={
                                              menu?.action[
                                                menu?.action?.findIndex(
                                                  (i) =>
                                                    i?.action === "insert-own"
                                                )
                                              ]?.status === "not_available"
                                            }
                                          >
                                            Insert Own
                                          </Radio> */}
                                            </Radio.Group>
                                          </div>
                                        </div>

                                        <div className={"m-2"}>
                                          <div className="mt-4">Update</div>
                                          <div
                                            className={style.radio + " flex"}
                                          >
                                            <Radio.Group
                                              onChange={(e) =>
                                                onRadio(e, menu.code, "update")
                                              }
                                              className="flex"
                                              value={
                                                dataSent?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":update"
                                                ) >= 0
                                                  ? "update"
                                                  : dataSent?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code +
                                                          ":update-own"
                                                    ) >= 0
                                                  ? "update-own"
                                                  : ""
                                              }
                                            >
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":updated"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action === "update"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                                value="update"
                                              >
                                                All
                                              </Radio>
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":updated"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                value="update-own"
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action ===
                                                        "update-own"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                              >
                                                Own
                                              </Radio>
                                            </Radio.Group>
                                          </div>
                                        </div>

                                        <div className={"m-2"}>
                                          <div className="mt-4">Delete</div>
                                          <div className={style.radio}>
                                            <Radio.Group
                                              onChange={(e) =>
                                                onRadio(e, menu.code, "delete")
                                              }
                                              className="flex"
                                              value={
                                                dataSent?.findIndex(
                                                  (i) =>
                                                    i === menu.code + ":delete"
                                                ) >= 0
                                                  ? "delete"
                                                  : dataSent?.findIndex(
                                                      (i) =>
                                                        i ===
                                                        menu.code +
                                                          ":delete-own"
                                                    ) >= 0
                                                  ? "delete-own"
                                                  : ""
                                              }
                                            >
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":delete"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action === "delete"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                                value="delete"
                                              >
                                                All
                                              </Radio>
                                              <Radio
                                                onClick={
                                                  dataSent?.findIndex(
                                                    (i) =>
                                                      i === el.code + ":delete"
                                                  ) >= 0
                                                    ? ""
                                                    : (e) =>
                                                        setRadio(e, menu.code)
                                                }
                                                value="delete-own"
                                                disabled={
                                                  menu?.action[
                                                    menu?.action?.findIndex(
                                                      (i) =>
                                                        i?.action ===
                                                        "delete-own"
                                                    )
                                                  ]?.status === "not_available"
                                                }
                                              >
                                                Own
                                              </Radio>
                                            </Radio.Group>
                                          </div>
                                        </div>
                                        </>
                                                  )}
                                      </div>
                                    </div>
                                    {isOpenService === true &&
                                    i === indexService ? (
                                      <>
                                        {itemMenu?.map((menus, i) => {
                                          return (
                                            <>
                                              <div className="ml-10 pb-10">
                                                <div className="flex justify-between pt-[10px] pr-10 pb[10px] w-full">
                                                  <div className="color-black font-medium mt-[10px] text-left text-2xl">
                                                    Level 3 - {menus.name}
                                                  </div>
                                                </div>
                                                {/* permission service */}
                                                <div className="flex font-medium">
                                                  <div className={"m-2"}>
                                                    <div className="mt-4">
                                                      View
                                                    </div>
                                                    <div
                                                      className={style.radio}
                                                    >
                                                      <Radio.Group
                                                        onChange={(e) =>
                                                          onRadio(
                                                            e,
                                                            menus.code,
                                                            "view"
                                                          )
                                                        }
                                                        className="flex"
                                                        value={
                                                          dataSent?.findIndex(
                                                            (i) =>
                                                              i ===
                                                              menus.code +
                                                                ":view"
                                                          ) >= 0
                                                            ? "view"
                                                            : dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":view-own"
                                                              ) >= 0
                                                            ? "view-own"
                                                            : ""
                                                        }
                                                      >
                                                        
                                                        <Radio
                                                          onClick={
                                                            dataSent?.findIndex(
                                                              (i) =>
                                                                i ===
                                                                el.code +
                                                                  ":view"
                                                            ) >= 0
                                                              ? ""
                                                              : (e) =>
                                                                  setRadio(
                                                                    e,
                                                                    menus.code
                                                                  )
                                                          }
                                                          disabled={
                                                            menus?.action[
                                                              menus?.action?.findIndex(
                                                                (i) =>
                                                                  i?.action ===
                                                                  "view"
                                                              )
                                                            ]?.status ===
                                                            "not_available"
                                                          }
                                                          value="view"
                                                        >
                                                          All
                                                        </Radio>
                                                        {
                                                          menus.code === "order.gromart.grouppayment" ?
                                                          <></>:
                                                          <Radio
                                                          onClick={
                                                            dataSent?.findIndex(
                                                              (i) =>
                                                                i ===
                                                                el.code +
                                                                  ":view"
                                                            ) >= 0
                                                              ? ""
                                                              : (e) =>
                                                                  setRadio(
                                                                    e,
                                                                    menus.code
                                                                  )
                                                          }
                                                          value="view-own"
                                                          disabled={
                                                            menus?.action[
                                                              menus?.action?.findIndex(
                                                                (i) =>
                                                                  i?.action ===
                                                                  "view-own"
                                                              )
                                                            ]?.status ===
                                                            "not_available"
                                                          }
                                                        >
                                                          Own
                                                        </Radio>
                                                        }
                                                       
                                                      </Radio.Group>
                                                    </div>
                                                  </div>

                                                  {menus.code ===
                                                    "setup.profile.address" ||
                                                  menus.code ===
                                                    "setup.profile.company" || menus.code==="order.gromart.gromartorderrequest" ? (
                                                    <></>
                                                  ) : (
                                                    <>
                                                  <div className={"m-2"}>
                                                    <div className="mt-4">
                                                      Insert
                                                    </div>
                                                    <div
                                                      className={style.radio}
                                                    >
                                                      <Radio.Group
                                                        onChange={(e) =>
                                                          onRadio(
                                                            e,
                                                            menus.code,
                                                            "insert"
                                                          )
                                                        }
                                                        className="flex"
                                                        value={
                                                          dataSent?.findIndex(
                                                            (i) =>
                                                              i ===
                                                              menus.code +
                                                                ":insert"
                                                          ) >= 0
                                                            ? "insert"
                                                            : dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":insert-own"
                                                              ) >= 0
                                                            ? "insert-own"
                                                            : ""
                                                        }
                                                      >
                                                        <Radio
                                                          onClick={
                                                            dataSent?.findIndex(
                                                              (i) =>
                                                                i ===
                                                                el.code +
                                                                  ":insert"
                                                            ) >= 0
                                                              ? ""
                                                              : (e) =>
                                                                  setRadio(
                                                                    e,
                                                                    menus.code
                                                                  )
                                                          }
                                                          disabled={
                                                            menus?.action[
                                                              menus?.action?.findIndex(
                                                                (i) =>
                                                                  i?.action ===
                                                                  "insert"
                                                              )
                                                            ]?.status ===
                                                            "not_available"
                                                          }
                                                          value="insert"
                                                        >
                                                          All
                                                        </Radio>
                                                        {/* <Radio
                                                      onClick={dataSent?.findIndex((i)=>i === el.code+":insert")>=0 ? "":(e) =>
                                              setRadio(e, menus.code)
                                            }
                                                      value="insert-own"
                                                      disabled={
                                                        menus?.action[
                                                          menus?.action?.findIndex(
                                                            (i) =>
                                                              i?.action ===
                                                              "insert-own"
                                                          )
                                                        ]?.status ===
                                                        "not_available"
                                                      }
                                                    >
                                                      Insert Own
                                                    </Radio> */}
                                                      </Radio.Group>
                                                    </div>
                                                  </div>
                                                  </>
                                                  )}

                                                  {menus.code ===
                                                    "order.routes.tripplanning"|| menus.code ==="order.request.request" || menus.code==="order.gromart.gromartorderrequest"  ? (
                                                    <></>
                                                  ) : (
                                                    <>

                                                  <div className={"m-2"}>
                                                    <div className="mt-4">
                                                      Update
                                                    </div>
                                                    <div
                                                      className={
                                                        style.radio + " flex"
                                                      }
                                                    >
                                                      <Radio.Group
                                                        onChange={(e) =>
                                                          onRadio(
                                                            e,
                                                            menus.code,
                                                            "update"
                                                          )
                                                        }
                                                        className="flex"
                                                        value={
                                                          dataSent?.findIndex(
                                                            (i) =>
                                                              i ===
                                                              menus.code +
                                                                ":update"
                                                          ) >= 0
                                                            ? "update"
                                                            : dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":update-own"
                                                              ) >= 0
                                                            ? "update-own"
                                                            : ""
                                                        }
                                                      >
                                                        <Radio
                                                          onClick={
                                                            dataSent?.findIndex(
                                                              (i) =>
                                                                i ===
                                                                el.code +
                                                                  ":update"
                                                            ) >= 0
                                                              ? ""
                                                              : (e) =>
                                                                  setRadio(
                                                                    e,
                                                                    menus.code
                                                                  )
                                                          }
                                                          disabled={
                                                            menus?.action[
                                                              menus?.action?.findIndex(
                                                                (i) =>
                                                                  i?.action ===
                                                                  "update"
                                                              )
                                                            ]?.status ===
                                                            "not_available"
                                                          }
                                                          value="update"
                                                        >
                                                          All
                                                        </Radio>
                                                        {
                                                          menus.code === "order.gromart.grouppayment" ?
                                                          <></>:
                                                          <Radio
                                                          onClick={
                                                            dataSent?.findIndex(
                                                              (i) =>
                                                                i ===
                                                                el.code +
                                                                  ":update"
                                                            ) >= 0
                                                              ? ""
                                                              : (e) =>
                                                                  setRadio(
                                                                    e,
                                                                    menus.code
                                                                  )
                                                          }
                                                          value="update-own"
                                                          disabled={
                                                            menus?.action[
                                                              menus?.action?.findIndex(
                                                                (i) =>
                                                                  i?.action ===
                                                                  "update-own"
                                                              )
                                                            ]?.status ===
                                                            "not_available"
                                                          }
                                                        >
                                                          Own
                                                        </Radio>
                                                        }
                                                        
                                                      </Radio.Group>
                                                    </div>
                                                  </div>
                                                  </>
                                                  )}

                                                  {menus.code ===
                                                    "order.routes.tripplanning" ||
                                                  menus.code ===
                                                    "order.routes.alltrip" ||
                                                  menus.code ===
                                                    "setup.profile.company" ||
                                                  menus.code ===
                                                    "setup.profile.address" || menus.code==="order.gromart.gromart" || menus.code==="order.gromart.gromartorderrequest"|| menus.code ==="order.gromart.grouppayment"? (
                                                    <></>
                                                  ) : (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Delete
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            onChange={(e) =>
                                                              onRadio(
                                                                e,
                                                                menus.code,
                                                                "delete"
                                                              )
                                                            }
                                                            className="flex"
                                                            value={
                                                              dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":delete"
                                                              ) >= 0
                                                                ? "delete"
                                                                : dataSent?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":delete-own"
                                                                  ) >= 0
                                                                ? "delete-own"
                                                                : ""
                                                            }
                                                          >
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":delete"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "delete"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                              value="delete"
                                                            >
                                                              All
                                                            </Radio>
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":delete"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              value="delete-own"
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "delete-own"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                            >
                                                              Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}

                                                  {menus.code ===
                                                  "order.routes.tripplanning" || menus.code === "order.gromart.gromartorderrequest" ? (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Approve
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            onChange={(e) =>
                                                              onRadio(
                                                                e,
                                                                menus.code,
                                                                "approve"
                                                              )
                                                            }
                                                            className="flex"
                                                            value={
                                                              dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":approve"
                                                              ) >= 0
                                                                ? "approve"
                                                                : dataSent?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":approve-own"
                                                                  ) >= 0
                                                                ? "approve-own"
                                                                : ""
                                                            }
                                                          >
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":approve"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "approve"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                              value="approve"
                                                            >
                                                              All
                                                            </Radio>
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":approve"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              value="approve-own"
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "approve-own"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                            >
                                                              Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Reject
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            onChange={(e) =>
                                                              onRadio(
                                                                e,
                                                                menus.code,
                                                                "reject"
                                                              )
                                                            }
                                                            className="flex"
                                                            value={
                                                              dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":reject"
                                                              ) >= 0
                                                                ? "reject"
                                                                : dataSent?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":reject-own"
                                                                  ) >= 0
                                                                ? "reject-own"
                                                                : ""
                                                            }
                                                          >
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":reject"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "reject"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                              value="reject"
                                                            >
                                                              All
                                                            </Radio>
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":reject"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              value="reject-own"
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "reject-own"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                            >
                                                              Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : menus.code ===
                                                    "order.routes.alltrip" ? (
                                                    <>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          Start
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            onChange={(e) =>
                                                              onRadio(
                                                                e,
                                                                menus.code,
                                                                "start"
                                                              )
                                                            }
                                                            className="flex"
                                                            value={
                                                              dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":start"
                                                              ) >= 0
                                                                ? "start"
                                                                : dataSent?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":start-own"
                                                                  ) >= 0
                                                                ? "start-own"
                                                                : ""
                                                            }
                                                          >
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":start"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "start"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                              value="start"
                                                            >
                                                              All
                                                            </Radio>
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":start"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              value="start-own"
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "start-own"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                            >
                                                              Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                      <div className={"m-2"}>
                                                        <div className="mt-4">
                                                          End
                                                        </div>
                                                        <div
                                                          className={
                                                            style.radio
                                                          }
                                                        >
                                                          <Radio.Group
                                                            onChange={(e) =>
                                                              onRadio(
                                                                e,
                                                                menus.code,
                                                                "end"
                                                              )
                                                            }
                                                            className="flex"
                                                            value={
                                                              dataSent?.findIndex(
                                                                (i) =>
                                                                  i ===
                                                                  menus.code +
                                                                    ":end"
                                                              ) >= 0
                                                                ? "end"
                                                                : dataSent?.findIndex(
                                                                    (i) =>
                                                                      i ===
                                                                      menus.code +
                                                                        ":end-own"
                                                                  ) >= 0
                                                                ? "end-own"
                                                                : ""
                                                            }
                                                          >
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":end"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "end"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                              value="end"
                                                            >
                                                              All
                                                            </Radio>
                                                            <Radio
                                                              onClick={
                                                                dataSent?.findIndex(
                                                                  (i) =>
                                                                    i ===
                                                                    el.code +
                                                                      ":end"
                                                                ) >= 0
                                                                  ? ""
                                                                  : (e) =>
                                                                      setRadio(
                                                                        e,
                                                                        menus.code
                                                                      )
                                                              }
                                                              value="end-own"
                                                              disabled={
                                                                menus?.action[
                                                                  menus?.action?.findIndex(
                                                                    (i) =>
                                                                      i?.action ===
                                                                      "end-own"
                                                                  )
                                                                ]?.status ===
                                                                "not_available"
                                                              }
                                                            >
                                                              Own
                                                            </Radio>
                                                          </Radio.Group>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    </>: <></>}
                                  </>
                                );
                              })}
                            </div>
                          </>
                        ) : null}
                      </>
                    }
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          );
        })}
      </>
    );
  };

  const items = [
    {
      key: 1,
      label: t("DRIVER:DETAIL"),
      children: Detail(),
    },
    {
      key: 2,
      label: t("DRIVER:PERMISSION"),
      children: Permission(),
    },
  ];

  const actModal = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.ROLE.LIST,
    });
  };
  return (
    <>
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been added"
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messageFail}
      />
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.ROLE.LIST}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Admin`}
          menuLevel2={`User Management`}
          menuLevel3={`Role`}
          menuLevel4={`Add Role`}
        />

        <div className="flex items-center justify-between">
          <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.ROLE.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />
            <h1 className="font-sans-bold text-2xl" id="title">
              Add Role
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            {/* <img src={RoleStep} /> */}
            {/* <div className=' bg-white-100 p-5 rounded-[10px] h-96'> */}
            <div className="w-1/2 mt-5">
              <Row className="bg-[#F3F3F3] h-[52px] rounded-md">
                <Col span={12}>
                  <Row>
                    <Col className="grid place-items-center h-[52px]" span={4}>
                      <div
                        className={`border ${
                          page === 1
                            ? "border-red-100 bg-red-100"
                            : "border-[#228B22] bg-[#228B22]"
                        } rounded-full w-[36px] h-[36px] grid place-items-center`}
                      >
                        <p className="font-sans text-xl font-semibold text-white-100">
                          1
                        </p>
                      </div>
                    </Col>
                    <Col className="flex items-center" span={12}>
                      <p
                        className={`font-sans ml-1 text-xl font-bold ${
                          page === 1 ? "text-red-100" : "text-[#228B22]"
                        }`}
                      >
                        {" "}
                        Detail Role{" "}
                      </p>
                    </Col>
                    <Col className="flex items-center" span={8}>
                      <hr
                        className={`border-2 w-full ${
                          page === 1
                            ? " border-[#D7D7D7] border-dashed "
                            : "border-[#228B22] border-solid"
                        } `}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col className="grid place-items-center h-[52px]" span={4}>
                      <div
                        className={`border rounded-full w-[36px] h-[36px] grid place-items-center ${
                          page === 1
                            ? "bg-[#FFFFFF] border-[#FFFFFF]"
                            : "border-red-100 bg-red-100"
                        }`}
                      >
                        <p
                          className={`font-sans text-xl font-semibold ${
                            page === 1 ? "text-[#ACACAC]" : "text-white-100"
                          }`}
                        >
                          2
                        </p>
                      </div>
                    </Col>
                    <Col className="flex items-center" span={20}>
                      <p
                        className={`font-sans ml-1 text-xl font-bold ${
                          page === 1 ? "text-[#ACACAC]" : "text-red-100"
                        }`}
                      >
                        {" "}
                        Set Permission{" "}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            {/* </div> */}
            {/* <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            /> */}
            {!loading ? (page === 1 ? Detail() : Permission()) : "loading..."}
          </div>
        </div>
        <div className="flex flex-row-reverse gap-[16px]">
          {page === 1 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => handleNext()}
              />
              <SecondaryButton
                action={
                  change
                    ? () => setShowConfirm(true)
                    : () => navigate(ROUTES.ROLE.LIST)
                }
                text={t("USER_DETAIL:CANCEL")}
              />
            </>
          ) : (
            <>
              <PrimaryButton text={t("Submit")} action={() => onSubmit()} />
              <SecondaryButton text={t("Previous")} action={() => setPage(1)} />
            </>
          )}
          {/* <PrimaryButton text={t("USER_DETAIL:SAVE")} action ={()=>onSubmit()} />
          <SecondaryButton text={t("USER_DETAIL:CANCEL")} /> */}
        </div>
      </div>
    </>
  );
};
export default RoleAdd;
